import { apiRequest } from '../../../../shared/api/index.js';

export const deleteBankData = async (): Promise<void> => {
  await apiRequest<void>('/bank/connection', { method: 'DELETE' });
};
